<script>
import { Line } from 'vue-chartjs';
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips';
import { getStyle } from '@coreui/coreui-pro/dist/js/coreui-utilities';

export default {
  extends: Line,
  props: ['height', 'width'],
  mounted() {
    const brandPrimary = getStyle('--primary') || '#20a8d8';
    const datasets1 = [
      {
        label: 'Active Users',
        backgroundColor: brandPrimary,
        borderColor: 'rgba(255,255,255,.55)',
        data: new Array(24).fill(0)
      }
    ];

    const last24hours = () => {
      const hourStack = [];
      const ts = Math.round(new Date().getTime() / 1000);
      for (let i = 0; i <= 24; i++) {
        let currentHours = ts - i * 3600;
        let da = new Date(currentHours * 1000);
        let displayTime =
          (da.getHours() > 12 ? da.getHours() - 12 : da.getHours()) +
          ':00 ' +
          (da.getHours() > 12 ? 'PM' : 'AM');
        hourStack.push(displayTime);
      }
      return hourStack;
    };

    this.renderChart(
      {
        labels: last24hours(),
        datasets: datasets1
      },
      {
        tooltips: {
          enabled: false,
          custom: CustomTooltips
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: 'transparent',
                zeroLineColor: 'transparent'
              },
              ticks: {
                fontSize: 2,
                fontColor: 'transparent'
              }
            }
          ],
          yAxes: [
            {
              display: false,
              ticks: {
                display: false,
                min: Math.min.apply(Math, datasets1[0].data) - 5,
                max: Math.max.apply(Math, datasets1[0].data) + 5
              }
            }
          ]
        },
        elements: {
          line: {
            borderWidth: 1
          },
          point: {
            radius: 4,
            hitRadius: 10,
            hoverRadius: 4
          }
        }
      }
    );
  }
};
</script>
